import React, { FC } from 'react'

import { Txt, Tooltip } from 'src/components/atoms'

type Props = {
  children: React.ReactElement<any, any>
}

export const AddInternalUserTooltip: FC<Props> = ({ children }) => {
  return (
    <Tooltip
      placement="top"
      content={
        <Txt sizeType="s">
          指定メールアドレスへ仮パスワードが記載
          <br />
          されたメールが送信されます。
          <br />
          <br />
          追加したユーザーを特定のROOV compass
          <br />
          へログインさせるためには
          <span className="tw-text-errorRed-default">
            <b>
              プロジェクト詳細
              <br />
              の「アサイン」から追加する必要があります。
            </b>
          </span>
        </Txt>
      }
    >
      {children}
    </Tooltip>
  )
}
